define('modules/editor/models/groupstate',['require','exports','module','backbone'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone");
  var GroupItem = Backbone.Model.extend({
    defaults: {
      view: null,
      top: 0,
      left: 0,
      width: 0,
      height: 0
    },
    initialize: function(options){
      var model = options.view.model,
          geometry = model.getPropertyGroup(model.geometryProperty);
      this.listenTo(geometry, "change", this._updatePositionFromModel);
      this.listenTo(this, "change", this.moveElement);
      //this.listenTo(this, "change:view", this._updateView);
    },
    updatePosition: function(dX, dY){
      this._updateLeft(dX);
      this._updateTop(dY);
      this.trigger("change");
    },
    _updateTop: function(dY){
      var top = this.get("top");
      this.set("top", top + dY, {silent: true});
    },
    _updateLeft: function(dX){
      var left = this.get("left");
      this.set("left", left + dX, {silent: true});
    },
    updateModelPosition: function(dx, dy) {
      var model = this.get("view").model,
          currentPos = (_.isFunction(model.getPosition)? model.getPosition() : {}),
          newPos;
      if (_.isFunction(model.setPosition)){
        newPos = {
          x: currentPos.x + dx,
          y: currentPos.y + dy
        };
        model.setPosition(newPos);
        this._updatePositionFromModel();
      }
    },
    // it may seem nonsensical, but it's needed since moving with the keys updates
    // the model directly, not the group, as it happens with moving with the mouse
    _updatePositionFromModel: function() {
      var model = this.get("view").model,
          pos = model.getPosition(),
          size = model.getSize(),
          offset = this._getTranslationOffset();
      this.set({
        left: pos.x + offset.x,
        top: pos.y + offset.y,
        height: +size.height,
        width: +size.width
      });
    },
    updateModelSize: function(dw, dh) {
      var model = this.get("view").model,
          currentSize = (_.isFunction(model.getSize)? model.getSize() : {}),
          newSize;
      if (_.isFunction(model.setSize)){
        newSize = {
          width: currentSize.width + dw,
          height: currentSize.height + dh
        };
        model.setSize(newSize);
      }
    },
    moveElement: function(){
      var offset = this._getTranslationOffset();
      this.get("view").$el.css({
        left: parseInt(this.get("left") - offset.x),
        top: parseInt(this.get("top") - Math.floor(offset.y))
      });
    },
    replaceView: function(newView) {
      this.set("view", newView, {silent: true});
      var offset = newView.parent.model.getPosition(),
          translation = this._getTranslationOffset(),
          pagePadding = parseInt($(".lpg-page").css("padding-top"));
      newView.$el.css({
        left: this.get("left") - (translation.x || offset.x),
        top: this.get("top") - (translation.y || offset.y + pagePadding)
      });
    },
    setRelativePosition: function(pos){
      var offset = this._getTranslationOffset();
      this.set("left", Math.max(pos.x, 0) + offset.x, {silent: true});
      this.set("top", Math.max(pos.y, 0) + offset.y, {silent: true});
      this.trigger("change");
    },
    _getTranslationOffset: function() {
      var view = this.get("view"),
          parentCoords = view.parent.$el.offset(),
          pageCoords = view.parent.$el.parents(".lpg-page").offset() || $(".lpg-page").offset();
      return {
        x: Math.max(0, parentCoords.left - pageCoords.left),
        y: Math.max(0, parentCoords.top - pageCoords.top)
      };
    }
  });

  var Group = Backbone.Collection.extend({
    model: GroupItem,
    toggleClass: function(className, isActive) {
      this.each(function(item){
        item.get("view").$el.toggleClass(className, isActive);
      });
    }
  });

  module.exports = Backbone.Model.extend({
    defaults: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    },
    initialize: function(attrs, options){
      this.elements = new Group();
      this.elements.on("add", function(item){
        item.get("view").model._grouped = true;
      });
      this.elements.on("remove", _.bind(function(item){
        item.get("view").model._grouped = false;
        this.recalculateSize();
      }, this));
    },
    add: function(elementView){
      var absCoords = elementView.$el.offset(),
          pageCoords = elementView.$el.parents(".lpg-page").offset() || { top: 0, left: 0},
          sectionView = elementView.parent.$el,
          elTop = absCoords.top - pageCoords.top - parseInt(sectionView.css("border-top-width")) || 0,
          elLeft = absCoords.left - pageCoords.left - parseInt(sectionView.css("border-left-width")) || 0,
          elWidth = +elementView.$el.outerWidth(),
          elHeight = +elementView.$el.outerHeight(),
          item = new GroupItem({
            view: elementView
          });

      this.listenTo(item, "change", this.recalculateSize);
      this.elements.add(item);
      item.set({
        top: parseInt(elTop),
        left: parseInt(elLeft),
        width: parseInt(elWidth),
        height: parseInt(elHeight)
      });
      //console.log("Added " + elementView.model.name + " {", elTop, elLeft, elWidth, elHeight + "}");
    },
    remove: function(elementView){
      var existing = this.contains(elementView);
      if(existing !== undefined){
        existing.stopListening();
        this.stopListening(existing);
        this.elements.remove(existing);
      }
    },
    recalculateSize: function() {
      this._calculateGroupDimensions();
      this._notifyChange();
    },
    getParent: function() {
      var first = this.getFirstView();
      return first && first.parent.$el;
    },
    isInTheSameSection: function(view) {
      var first = this.getFirstView(),
          groupParentSection = first && first.parent.model,
          theyAre = groupParentSection && groupParentSection.contains(view.model);
      return !first || theyAre;
    },
    contains: function(elementView){
      return this.elements.find(function(item){
        return item.get("view") === elementView;
      });
    },
    containsElement: function(elementModel){
      return this.elements.find(function(item){
        return item.get("view").model === elementModel;
      });
    },
    addOrRemove: function(elementView){
      var existing = this.contains(elementView);
      if(existing){
        this.remove(elementView);
      }
      else {
        this.add(elementView);
      }
    },
    clear: function(){
      this.elements.each(function(item){
        item.get("view").model._grouped = false;
      });
      this.elements.reset();
      this._calculateGroupDimensions();
      this._notifyChange();
    },
    // when an element changes its section, the view changes and the one
    // in GroupState is obsolete so must be replaced with a newer one
    replaceViewWith: function(newView) {
      var item = this.containsElement(newView.model);
      return item && item.replaceView(newView);
    },
    getGroupCount: function(){
      return this.elements.length;
    },
    getFirstView: function(){
      var first = this.elements.first();
      return first && first.get("view");
    },
    getItemByView: function(view) {
      return this.elements.find(function(item){
        return item.get("view").cid === view.cid;
      });
    },
    getGroupDimensions: function(){
      return {
        top: this.get("top"),
        left: this.get("left"),
        right: this.get("right"),
        bottom: this.get("bottom")
      };
    },
    getGroupAbsoluteDimensions: function() {
      var first = this.getFirstView(),
          offset = first.$el.parents(".lpg-page").offset();
      return {
        top: this.get("top") + offset.top,
        bottom: this.get("bottom") + offset.top,
        left: this.get("left") + offset.left,
        right: this.get("right") + offset.left
      };
    },
    updatePosition: function(dX, dY){
      var left = this.get("left"),
          top = this.get("top"),
          right = this.get("right"),
          bottom = this.get("bottom");
      this.set({
        top: top + dY,
        left: left + dX,
        bottom: bottom + dY,
        right: right + dX
      });
      this.elements.invoke("updatePosition", dX, dY);
    },
    refreshView: function(view) {
      var item = this.getItemByView(view);
      return item && item._updatePositionFromModel();
    },
    updateModelsPosition: function(dX, dY){
      this.elements.invoke("updateModelPosition", dX, dY);
    },
    updateModelsSize: function(dX, dY){
      this.elements.invoke("updateModelSize", dX, dY);
    },
    _notifyChange: function(){
      //console.log("GroupState change", this.toJSON(), this.elements.length);
      this.trigger("change:group", this, this.elements);
    },
    _calculateGroupDimensions: function(){
      //reset first
      this.set({
        top: 100000,
        left: 100000,
        bottom: 0,
        right: 0
      }, { silent: true });
      this.elements.each(function(item){
        if(item.get("top") < this.get("top")){
          this.set("top", item.get("top"));
        }
        if(item.get("left") < this.get("left")){
          this.set("left", item.get("left"));
        }
        if((item.get("left") + item.get("width")) > this.get("right")){
          this.set("right", item.get("left") + item.get("width"));
        }
        if((item.get("top") + item.get("height")) > this.get("bottom")){
          this.set("bottom", item.get("top") + item.get("height"));
        }
      }, this);
    }
  });
});

